module.exports = __webpack_public_path__ + "img/eng.9d5d7e74.png";